import { useState, useEffect } from "react";
import TabNav from "../../composants/TabNav/TabNav";
import './Assistance.css';
import faq from "../../Data/faq.json";
import glossary from "../../Data/glossary.json";
import guides from "../../Data/guides.json";
import contactFaq from "../../Data/contactFaq.json";
import Button from "../../composants/Button/Button";
import { ReactComponent as PdfIcon } from '../../assets/icons/pdf.svg';
import { ReactComponent as MailIcon } from '../../assets/icons/mail-blanc.svg';
import { ReactComponent as TicketIcon } from '../../assets/icons/ticket-blanc.svg';
import TicketForm from "../../composants/Ticket/TicketForm/TicketForm";
import { useAuth } from "../../contexts/AuthContext";
import TicketsTab from "../../composants/Ticket/TicketTab/TicketTab.tsx";
import { useTickets } from "../../hooks/useTickets";

export default function CentralisPage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [openIndex, setOpenIndex] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { tickets, loading: ticketsLoading, error: ticketsError, reload: reloadTickets } = useTickets();

    const handleSelectionChange = (selectedIds: string[]) => {
    setSelectedItems(selectedIds);
  };


  // const columns = [
  //   { field: 'ticket_no', header: 'Numéro de ticket', sortable: true },
  //   { field: 'office_id', header: 'ID du bureau', sortable: true },
  //   { field: 'response_id', header: 'ID de réponse', sortable: true },
  //   { field: 'user_id', header: 'ID utilisateur', sortable: true },
  //   { field: 'subject', header: 'Sujet', sortable: true },
  //   { field: 'content', header: 'Contenu', sortable: true },
  //   { field: 'status', header: 'Statut', sortable: true },
  //   { field: 'priority', header: 'Priorité', sortable: true },
  //   { field: 'created_at', header: 'Date de création', sortable: true },
  //   { field: 'updated_at', header: 'Dernière mise à jour', sortable: true },
  //   { field:  'assignee_id', header: 'Assigné à', sortable: true },
  //   { field: 'is_escalated', header: 'Escaladé', sortable: true },
  //   { field: 'deleted_at', header: 'Supprimé le', sortable: true },
  //   { field: 'escalated_at', header: 'Escaladé le', sortable: true },



  // ];

//   const tickets = [
//   {
//     "id": 1,
//     "ticket_no": 1,
//     "office_id": 6,
//     "response_id": 1,
//     "user_id": 1,
//     "assignee_id": null,
//     "status": "OPEN",
//     "priority": "NORMAL",
//     "subject": "Test de ticket avec postman",
//     "content": "Cessi est un test de ticket pour vois si le TicketController fonctionne correctement",
//     "is_escalated": 0,
//     "created_at": "2025-11-19 15:36:08",
//     "updated_at": "2025-11-19 15:36:08",
//     "deleted_at": null,
//     "escalated_at": null
//   },
//   {
//     "id": 2,
//     "ticket_no": 2,
//     "office_id": 6,
//     "response_id": 2,
//     "user_id": 2,
//     "assignee_id": null,
//     "status": "OPEN",
//     "priority": "NORMAL",
//     "subject": "Problème d'accès API",
//     "content": "Impossible d'atteindre l'endpoint /api/tickets depuis l'application mobile.",
//     "is_escalated": 0,
//     "created_at": "2025-11-19 16:05:12",
//     "updated_at": "2025-11-19 16:05:12",
//     "deleted_at": null,
//     "escalated_at": null
//   },
//   {
//     "id": 3,
//     "ticket_no": 3,
//     "office_id": 6,
//     "response_id": 3,
//     "user_id": 3,
//     "assignee_id": null,
//     "status": "OPEN",
//     "priority": "NORMAL",
//     "subject": "Erreur lors de l'import CSV",
//     "content": "L'import CSV échoue avec l'erreur 'format invalide' sur la colonne montant.",
//     "is_escalated": 0,
//     "created_at": "2025-11-19 16:30:45",
//     "updated_at": "2025-11-19 16:30:45",
//     "deleted_at": null,
//     "escalated_at": null
//   }
// ]




  
  const handleRowClick = (rowData: any) => {
    console.log("Row clicked:", rowData);
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // bloque le scroll
    } else {
      document.body.style.overflow = ""; // réactive le scroll
    }

    return () => {
      document.body.style.overflow = ""; // sécurité au démontage
    };
  }, [showModal]);

  const renderTextWithLinks = (text: string) => {
    const parts = text.split(/(https?:\/\/[^\s]+)/g);
    return parts.map((part, i) =>
      part.match(/https?:\/\/[^\s]+/) ? (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="faq-link">
          {part}
        </a>
      ) : (
        <span key={i}>{part}</span>
      )
    );
  };

  const normalizeLetter = (letter: string) => {
    return letter.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  };

  const sortedGlossary = glossary.slice().sort((a, b) => {
    const termA = normalizeLetter(a.term);
    const termB = normalizeLetter(b.term);
    return termA.localeCompare(termB);
  });

  const tabs = ["Guides d'utilisation", "FAQ", "Glossaire", "Contact", "Tickets Support"];
  const inactiveTabs: number[] = [4]; // Index de "Tickets Support"

  return (
    <div className="assistance-container">
      <h1>Assistance</h1>

      <TabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(index) => setActiveTab(index)}
        inactiveTabs={inactiveTabs}
        inactiveTabsTooltips={{
          "Tickets Support": "Fonctionnalité en cours de développement"
        }}
      />
      {activeTab === 0 && (
        <div className="guides-container">
          {guides.map((guide, i) => {
            const youtubeId = guide["youtube-link"]
              ? new URL(guide["youtube-link"]).searchParams.get("v")
              : null;
            return (
              <div key={i} className="guide-card">
                <h3 className="guide-card-title">{guide.title}</h3>
                <p className="guide-card-description">{guide.description}</p>
                {youtubeId && (
                  <div className="guide-video-wrapper">
                    <iframe
                      src={`https://www.youtube.com/embed/${youtubeId}`}
                      title={guide.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
                {guide["pdf-link"] && (
                  <Button
                    className="guide-pdf-button"
                    type="link"
                    value={"Télécharger le guide au format PDF"}
                    linkHref={guide["pdf-link"]}
                    variant="secondary"
                    icon={<PdfIcon />}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
      {activeTab === 1 && (
        <div className="faq-container">
          {faq.map((section, i) => (
            <div key={i}>
              <h2 className="faq-header">{section.category}</h2>
              <div className="faq-content">
                {section.questions.map((item, j) => {
                  const index = `${i}-${j}`;
                  return (
                    <div key={index} className={`faq-question ${openIndex === index ? "active-question" : ""}`}>
                      <button onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                        <span className="faq-question-text">{item.q}</span>
                        {openIndex === index && <div className="faq-answer">{renderTextWithLinks(item.a)}</div>}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}

      {activeTab === 2 && (
        <div className="glossary-container-full">
          <ul className="glossary-list">
            {sortedGlossary.map((g, i) => (
              <li key={i} className="glossary-list-item">
                <span className="glossary-item-term">{g.term}:</span> {g.def}
              </li>
            ))}
          </ul>
        </div>
      )}



      {activeTab === 3 && (
        <div className="contact-container">
          <p className="faq-header">
            Avant de contacter le support, voici quelques réponses aux problèmes les plus courants :
          </p>

          <div className="contact-faq-container">
            {contactFaq.map((section, i) => (
              <div key={i}>
                <h2 className="faq-header">{`${i + 1}. ${section.category}`}</h2>
                <div className="faq-content">
                  {section.questions.map((item, j) => {
                    const index = `contact-${i}-${j}`;
                    return (
                      <div key={index} className={`faq-question ${openIndex === index ? "active-question" : ""}`}>
                        <button onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                          <span className="faq-question-text">{`${j + 1}. ${item.q}`}</span>
                          {openIndex === index && <div className="faq-answer">{renderTextWithLinks(item.a)}</div>}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

         

          <div className="contact-button-container">
            <p>Si vous ne trouvez pas la réponse à votre question, contactez notre support :</p>
            <div className="action-buttons">
              <Button
                type="link"
                value="Envoyer un email au support"
                linkHref="mailto:contact@centralis-europe.com"
                variant="primary"
                size="small"
                icon={<MailIcon />}
                className="assistance-button"
              />
              {/* <Button
                type="button"
                value="Envoyer une demande de support"
                variant="primary"
                size="small"
                icon={<TicketIcon />}
                className="assistance-button"
                onClick={() => setShowModal(true)}
              /> */}
            </div>
          </div>
        </div>
      )}

          {activeTab === 4 && (
        <div className="tickets-support-container">
          <h2 className="ticket-header">
            Gérez vos demandes de support technique via notre système de tickets dédié
          </h2>

          <div className="contact-button-container">

            <Button
              type="button"
              value="Recharger les tickets"
              variant="secondary"
              size="small"
              className="assistance-button"
              onClick={reloadTickets}
              disabled={ticketsLoading}
            />

          {ticketsLoading && <p className="ticket-reload-text">Chargement des tickets...</p>}
          {ticketsError && <p className="ticket-error">Erreur lors du chargement des tickets.</p>}

          {!ticketsLoading && !ticketsError && (
            <TicketsTab
              tickets={tickets}
              showId
              showSubject
              showLastModification
              showStatus
              showPriority
              showButton
            />
          )}
                    </div>


          <div className="contact-button-container">
            
            <Button
              type="button"
              value="Ouvrir un ticket de support"
              variant="primary"
              size="small"
              icon={<TicketIcon />}
              className="assistance-button"
              onClick={() => setShowModal(true)}
            />
          </div>
        </div>
      )}
      

      {/* {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content ticket" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            <TicketForm currentUser={user ? user : null} />
          </div>
        </div>
      )} */}
    </div>
  );
}